import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateProposalsAmazonInput,
    ProposalsAmazon,
    UpdateProposalsAmazonInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class ProposalsAmazonService {
    private amplifyClient = generateClient();
    constructor() {}

    async listProposalsAmazons(): Promise<ProposalsAmazon[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listProposalsAmazons
                })
            ).data.listProposalsAmazons.items;
            if (data) return data as ProposalsAmazon[];
        } catch (error) {
            console.error('Error finding ProposalsAmazon:', error);
            return null;
        }
    }

    async createProposalsAmazon(
        input: CreateProposalsAmazonInput
    ): Promise<ProposalsAmazon> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createProposalsAmazon,
                    variables: {
                        input
                    }
                })
            ).data.createProposalsAmazon;
            if (date) return date as ProposalsAmazon;
        } catch (error) {
            console.error('Error creating ProposalsAmazon:', error);
            return null;
        }
    }

    async updateProposalsAmazon(
        input: UpdateProposalsAmazonInput
    ): Promise<ProposalsAmazon> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProposalsAmazon,
                    variables: {
                        input
                    }
                })
            ).data.updateProposalsAmazon;
            if (date) return date as ProposalsAmazon;
        } catch (error) {
            console.error('Error updated ProposalsAmazon:', error);
            return null;
        }
    }
}
